import { CommonModule } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { Icon, ProfileImage } from '@malirang/front-share';
import { ContentFavoriteComponent } from '../components/content-favorite/content-favorite.component';
import { ContentImagesComponent } from '../components/content-images/content-images.component';
import { ContentShareComponent } from '../components/content-share/content-share.component';
import { ContentAdatper } from '../content.adatper';

@Component({
  selector: 'app-content-card',
  templateUrl: './content-card.component.html',
  imports: [
    Icon,
    CommonModule,
    ProfileImage,
    ContentShareComponent,
    ContentFavoriteComponent,
    ContentImagesComponent,
  ],
})
export class ContentCardComponent extends ContentAdatper {
  layout: InputSignal<string> = input<string>('');
  isGrid: Signal<boolean> = computed(() => this.layout() === 'grid');
}
